import { render } from "./mvt-ads.vue?vue&type=template&id=17bd4860"
import script from "./mvt-ads.js?vue&type=script&lang=js"
export * from "./mvt-ads.js?vue&type=script&lang=js"

import "./mvt-ads.vue?vue&type=style&index=0&id=17bd4860&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__